@if (formGroup) {
  <form [formGroup]="formGroup" class="w-100">
    <create-demand-form-entry
      [hideInputGroupElements]="true"
      [control]="formGroup.controls.deliveryTime"
      [label]="'Lieferzeit' | translate"
      >
      <div class="col">
        <div class="row align-items-center">
          <div class="col-auto">
            <iim-decimal-input-v2 formControlName="deliveryTime"></iim-decimal-input-v2>
          </div>
          <div class="col-auto px-0">
            <select class="form-control" formControlName="deliveryTimeUnit">
              <option [value]="DeliveryTimeUnit.HOURS">
                {{ DeliveryTimeUnit.HOURS | deliveryTime: formGroup.value.deliveryTime | translate }}
              </option>
              <option [value]="DeliveryTimeUnit.DAYS">
                {{ DeliveryTimeUnit.DAYS | deliveryTime: formGroup.value.deliveryTime | translate }}
              </option>
              <option [value]="DeliveryTimeUnit.WEEKS">
                {{ DeliveryTimeUnit.WEEKS | deliveryTime: formGroup.value.deliveryTime | translate }}
              </option>
              <option [value]="DeliveryTimeUnit.MONTHS">
                {{ DeliveryTimeUnit.MONTHS | deliveryTime: formGroup.value.deliveryTime | translate }}
              </option>
            </select>
          </div>
        </div>
      </div>
    </create-demand-form-entry>
    <separator></separator>
    <create-demand-form-entry
      [hideInputGroupElements]="true"
      [control]="formGroup.controls.preferredDeliveryDate"
      [label]="'Gewünschter Liefertermin' | translate"
      >
      <div class="col">
        <iim-datepicker
          formControlName="preferredDeliveryDate"
          [placeholder]="'Liefertermin' | translate"
          [minDate]="today"
        ></iim-datepicker>
      </div>
    </create-demand-form-entry>
    <separator></separator>
    <div class="row">
      <div class="col">
        <mat-checkbox formControlName="partialDeliveryPossible">
          {{ 'Teillieferung möglich' | translate }}
        </mat-checkbox>
      </div>
    </div>
  </form>
}
